import { ApolloLink } from '@apollo/client';
import type { Operation, NextLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { Kind } from 'graphql';
import omitDeep from 'omit-deep-lodash';

/**
 * Strips __typename (and other keys if desired) from mutation variables
 * to avoid server-side schema complaints.
 */
export const cleanTypenameLink = new ApolloLink((operation: Operation, forward: NextLink) => {
  const keysToOmit = ['__typename']; // more keys like timestamps could be included here

  const def = getMainDefinition(operation.query);

  if (def && def.kind === Kind.OPERATION_DEFINITION && def.operation === 'mutation') {
    operation.variables = omitDeep(operation.variables, keysToOmit);
  }

  return forward ? forward(operation) : null;
});
